import { render, staticRenderFns } from "./SubClaim.vue?vue&type=template&id=4965ebc8&scoped=true&"
import script from "./SubClaim.vue?vue&type=script&lang=js&"
export * from "./SubClaim.vue?vue&type=script&lang=js&"
import style0 from "./SubClaim.vue?vue&type=style&index=0&id=4965ebc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965ebc8",
  null
  
)

export default component.exports